import { useState } from "react";

import TreatzSpaBookingForm from "./TreatzSpaBookingForm";
import TreatzSpaCompletion from "./TreatzSpaCompletion";

export default function TreatzSpa() {
  const [step, setStep] = useState(0);
  const [reservationId, setReservationId] = useState<number | null>(null);

  function goToCompletePage(reservationId: number) {
    setReservationId(reservationId);
    setStep(1);
  }

  return (
    <>
      {step === 0 && (
        <TreatzSpaBookingForm
          goToCompletePage={(reservationId) => goToCompletePage(reservationId)}
        />
      )}
      {step === 1 && reservationId !== null && (
        <TreatzSpaCompletion reservationId={reservationId} />
      )}
    </>
  );
}
